import React, { useState } from 'react'

import { Button } from 'Components/shared/Button'
import Input from 'Components/shared/Input'
import { ErrorText, SuccessText } from 'Components/shared/Typography'

import { Flex } from 'lese'

import VirtualOfficeService from 'Services/virtual-offices'

import { useInput, runOnEnter } from 'Helpers'
import { useQueryParams } from 'raviger'

export default () => {
  const [, setQueryParams] = useQueryParams()
  const [errorText, setErrorText] = useState()
  const [successText, setSuccessText] = useState()

  const titleHook = useInput('')

  const createVirtualOffice = async () => {
    const virtualOffice = await VirtualOfficeService.create({ title: titleHook.value }).catch(err =>
      setErrorText(err.message)
    )
    if (!virtualOffice) return
    setQueryParams({ id: virtualOffice.id })
    titleHook.reset()
    setSuccessText('Successfully created virtual office')
    setErrorText()
  }

  return (
    <Flex column separation="24px" xAlign="center">
      <Input
        placeholder="Title"
        {...titleHook.bind}
        onKeyDown={runOnEnter(createVirtualOffice)}
        tabIndex={0}
      />
      {errorText && <ErrorText>{errorText}</ErrorText>}
      {successText && <SuccessText>{successText}</SuccessText>}
      <Button onClick={createVirtualOffice}>Create Virtual Office</Button>
    </Flex>
  )
}
